import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/scene.svg
 */
const IconScene: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23.334 23.792H4.624a3.763 3.763 0 01-3.767-3.757v-9.504a.675.675 0 01.674-.676h21.793a.677.677 0 01.676.676v12.585a.678.678 0 01-.666.676zM2.21 11.206v8.84a2.406 2.406 0 002.41 2.407h18.038V11.217L2.21 11.206zM1.417 9.52a.674.674 0 01-.676-.554l-.73-3.999a.677.677 0 01.54-.789L21.986.219a.68.68 0 01.787.54l.738 4a.675.675 0 01-.539.787L1.532 9.51a.715.715 0 01-.115.01zm.047-4.134l.492 2.67 20.097-3.714-.49-2.673L1.465 5.386z"
      fill="currentColor"
    />
    <path
      d="M1.418 9.52a.679.679 0 01-.68-.671.698.698 0 01.121-.386l3.258-4.729a.677.677 0 01.92-.147.675.675 0 01.192.914L1.969 9.23a.666.666 0 01-.55.29zM18.244 6.413a.678.678 0 01-.594-.359.675.675 0 01.037-.693L20.943.63a.676.676 0 111.14.725l-.03.042-3.258 4.729a.677.677 0 01-.551.286zM7.063 8.47a.671.671 0 01-.592-.36.676.676 0 01.035-.693l3.243-4.731a.676.676 0 011.112.768l-3.243 4.73a.678.678 0 01-.555.286zM12.688 7.43a.682.682 0 01-.594-.36.677.677 0 01.033-.692l3.243-4.73a.676.676 0 011.112.767L13.24 7.146a.682.682 0 01-.55.284zM23.334 15.278H1.531a.673.673 0 01-.674-.676v-4.055a.675.675 0 01.674-.676h21.793a.677.677 0 01.676.676v4.055a.678.678 0 01-.666.676zM2.21 13.927h20.438v-2.704H2.21v2.704z"
      fill="currentColor"
    />
    <path
      d="M1.531 15.278a.68.68 0 01-.66-.807.678.678 0 01.184-.346l4.053-4.053a.678.678 0 01.957-.002.675.675 0 010 .957L2.01 15.083a.683.683 0 01-.479.195zM18.652 15.278a.677.677 0 01-.478-1.153l4.053-4.054a.678.678 0 011.155.478c0 .179-.073.351-.2.478l-4.053 4.055a.678.678 0 01-.477.196zM7.276 15.27a.68.68 0 01-.623-.42.681.681 0 01.146-.732l4.057-4.053a.67.67 0 01.736-.148.678.678 0 01.222 1.103l-4.06 4.054a.662.662 0 01-.478.196zM13.019 15.27a.671.671 0 01-.619-.418.676.676 0 01.144-.733l4.053-4.054a.68.68 0 01.956 0 .673.673 0 01.146.736.673.673 0 01-.146.22L13.5 15.073a.67.67 0 01-.481.196zM18.962 20.95H5.913a.672.672 0 01-.672-.675V17.15a.676.676 0 01.672-.676h13.05a.676.676 0 01.675.676v3.125a.679.679 0 01-.676.676zM6.6 19.6h11.686v-1.775H6.6V19.6z"
      fill="currentColor"
    />
    <path
      d="M12.439 20.95a.677.677 0 01-.676-.675V17.15a.675.675 0 111.35 0v3.125a.675.675 0 01-.674.676z"
      fill="currentColor"
    />
  </svg>
);

export default IconScene;
